import React from "react";

const CaseStudyCard = ({
  title,
  description,
  subDescription,
  imageUrl,
  left = true,
  pointList = [],
  imageClassName = "",
}) => {
  return (
    <div
      className={`py-[6%]  md:px-24 flex flex-col ${
        left ? "md:flex-row" : "md:flex-row-reverse"
      } md:space-x-16 justify-start items-start`}
    >
      <div className="flex flex-col items-start mt-8 px-4 md:px-0">
        <p className="text-base md:text-xl font-bold font-theBrittanySans">
          {title}
        </p>
        <h1 className="font-bold text-3xl md:text-[48px] leading-[140%] tracking-[0%] my-4">
          {description}
        </h1>
        <p className="font-medium text-lg md:text-[20px] leading-[140%] tracking-[0%] mb-4 md:mb-12">
          {subDescription}
        </p>
        {pointList && (
          <div className="hidden md:flex flex-row items-center justify-between w-full">
            {pointList.map((point) => (
              <CampaignLabelCard
                title={point.title}
                description={point.description}
              />
            ))}
          </div>
        )}
      </div>

      <div
        className={`relative overflow-hidden text-white aspect-[3/2] w-full md:w-auto md:min-w-[50%] flex flex-row`}
      >
        <img
          src={imageUrl}
          alt="AI Strategy"
          className={`w-full h-full object-cover absolute object-center grayscale ${imageClassName}`}
        />
        {/* Top Shadow */}
        <div className="absolute top-0 left-0 w-full h-10 md:h-20 bg-gradient-to-b from-app-background to-transparent z-10" />

        {/* Bottom Shadow */}
        <div className="absolute bottom-0 left-0 w-full h-10 md:h-20 bg-gradient-to-t from-app-background to-transparent z-10" />

        {/* Left Shadow */}
        <div className="absolute top-0 left-0 h-full w-10 md:w-20 bg-gradient-to-r from-app-background to-transparent z-10" />

        {/* Right Shadow */}
        <div className="absolute top-0 right-0 h-full w-10 md:w-20 bg-gradient-to-l from-app-background to-transparent z-10" />
      </div>

      <div className="md:hidden flex-row items-center justify-center w-full mt-[18%] mb-[12%] p-4 space-y-6 md:space-y-0">
        {pointList.map((point) => (
          <CampaignLabelCard
            title={point.title}
            description={point.description}
          />
        ))}
      </div>
    </div>
  );
};

function CampaignLabelCard({ title, description, className = "" }) {
  return (
    <div className={`flex flex-col items-start ${className}`}>
      <h1 className="text-[#AFAFAF] font-normal text-sm md:text-[16px] leading-[140%] tracking-[0%] uppercase">
        {title}
      </h1>
      <p className="font-normal text-lg md:text-[20px] leading-[140%] tracking-[0%]">
        {description}
      </p>
    </div>
  );
}

export default CaseStudyCard;
